import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onKeyup"]
const _hoisted_2 = {
  key: 1,
  class: "bi bi-dot d-block dot"
}

import { ref, watchEffect, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { formatter } from "@/shared/ts/formatter";
import Slider from "../common/Slider.vue";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { getCalendarYearText } from "@/guiide/ts/wants/wantsUtilities";


export default /*@__PURE__*/_defineComponent({
  __name: 'AnnualExpense',
  props: {
    modelValue: { type: Number, default: null },
    planYear: { type: Number, default: 1 },
    calendarYear: { type: Number, default: 2000 },
    startsOnJanFirst: { type: Boolean, default: false },
    max: { type: Number, default: 5000 },
    min: { type: Number, default: 0 },
    step: { type: Number, default: 50 },
    orientation: { type: String, default: "vertical" },
    showPlanYear: { type: Boolean, default: true },
    isSelected: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    showThumbLabel: { type: Boolean, default: true }
},
  emits: {
    'update:modelValue': null,
    'gotFocus': null
},
  setup(__props, { emit: __emit }) {

const props = __props;

const labelText = computed<string>(() => {
    return props.planYear % 2 != 0 ? props.planYear.toString() : "";
});

const showText = computed<boolean>(() => {
    return labelText.value.length > 0;
})

const emit = __emit;

const localModel = ref(props.modelValue);
const hasFocus = ref(false);
const yearLabel = ref(null);
const bootstrap: any = (window as any).bootstrap;
let tooltip;

onMounted(() => {
    if (yearLabel.value) {
        createTooltip(getTooltipText.value);
    }
});

onBeforeUnmount(() => {
    if (tooltip.value) {
        tooltip.dispose();
    }
});

const updateValue = (newValue: number) => {
    emit('update:modelValue', newValue);
    if (!props.isSelected) {
        emit('gotFocus');
    }
};

watchEffect(() => {
    localModel.value = props.modelValue;
});

function emitFocus(event: Event) {
    hasFocus.value = true;
    emit("gotFocus");
}

function onLostFocus() {
    hasFocus.value = false;
}

const trackColor = computed(() => {
    return hasFocus.value ? "#bfbfbf" : "#DCDCDC";
})

const thumbColor = computed(() => {
    if (props.isReadOnly) {
        return "#A9A9A9";
    }

    if (localModel.value < props.min) {
        return "#B22222";
    }

    return hasFocus.value ? "#32CD32" : "green";
});

const selectedTrackColor = computed(() => {
    return localModel.value < props.min
        ? "red"
        : "#A9A9A9";
});

const tooltipCalendarYear = computed<string>(() => getCalendarYearText(props.calendarYear, props.startsOnJanFirst));

const getTooltipText = computed<string>(() => {
    return `${tooltipCalendarYear.value}<br/>`
        + `Annual: ${formatter.formatCurrency(localModel.value)}`;
});

watch(getTooltipText, (newText) => {
    if (yearLabel.value) {
        if (tooltip) {
            tooltip.hide();
            tooltip.dispose();
        }
        createTooltip(newText);
    }
});

function getSliderAria(): string {
    return `Set your target income for retirement year ${props.planYear}`;
}

function createTooltip(tooltipHtml: string) {
    tooltip = new bootstrap.Tooltip(yearLabel.value, {
        html: true,
        placement: 'top',
        title: tooltipHtml,
        delay: 600,
        trigger: 'hover'
    });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-flex flex-column",
    onMousedown: emitFocus,
    onFocusout: onLostFocus,
    onKeyup: [
      _withKeys(_withModifiers(emitFocus, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers(emitFocus, ["prevent"]), ["space"])
    ],
    onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
  }, [
    _createVNode(Slider, {
      modelValue: localModel.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((localModel).value = $event)),
        updateValue
      ],
      min: 0,
      "selectable-min": 0,
      max: props.max,
      step: __props.step,
      readonly: __props.isReadOnly,
      "aria-label": getSliderAria()
    }, null, 8, ["modelValue", "max", "step", "readonly", "aria-label"]),
    _createElementVNode("label", {
      ref_key: "yearLabel",
      ref: yearLabel,
      class: _normalizeClass(["yearLabel border-rounded", { selected: __props.isSelected }]),
      "data-bs-toggle": "tooltip",
      "data-bs-html": "true",
      "data-bs-placement": "top",
      tabindex: "0"
    }, [
      (showText.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(labelText.value), 1)
          ], 64))
        : (_openBlock(), _createElementBlock("i", _hoisted_2))
    ], 2)
  ], 40, _hoisted_1))
}
}

})